module.exports = __webpack_public_path__ + "static/media/about_us_front.a3966cdc.jpeg";